import React from 'react';

import LinkMui from '@mui/material/Link';

const LinksCellRenderer = ({ value }) => {
  const items = Array.isArray(value) ? value : [];

  return (
    <>
      {items.map(({ referenceNumber, documentUrl }, index) => (
        <span key={referenceNumber}>
          <LinkMui href={documentUrl} target="_blank" rel="noopener noreferrer">
            {referenceNumber}
          </LinkMui>
          {index < items.length - 1 && ', '}
        </span>
      ))}
    </>
  );
};

export default LinksCellRenderer;
